import React, { useEffect, useRef, useState } from "react";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";

import getText from "Translator";
import Swal from "sweetalert2";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
// import { storeAccountFavorite } from "controllers/MainMenu";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import { getUnreadedNotifications } from "controllers/NotificationController";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { deleteFiles, setFileVisible } from "controllers/FileController";
import { setHeader } from "context";
import { setTitle } from "context";
import { useMaterialUIController } from "context";
import { displayErrorMessage } from "controllers/validation";
import {
  Checkbox,
  Divider,
  Drawer,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import NewPatientComponent from "./components/NewPatientComponent";
import EditPatientComponent from "./components/EditPatientComponent";
import SendToColleagueComponent from "./components/SendToColleagueComponent";

import { setNotification } from "context";
import { setAction } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { catchMessage } from "components/AlertComponent";

import { setLoading } from "context";
import { getUsersFilesWithCapsule } from "controllers/FileController";
import ClinicsComponent from "./components/ClicnicsComponenet";
let menuType = "title";
let fileMenuType = "capsule";
let SourceMenu = [];
let selectedItem;
let delay = 800;
let startPress = null;
export default function FileScreen(props) {
  const [menu, setMenu] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [search, setSearch] = useState("");
  const [searchDisplay, setSearchDisplay] = useState(false);
  const [open, setOpen] = useState(false);
  const [reload, setReload] = useState(new Date());
  const [mode, setMode] = useState("newfile");
  const [expanded, setExpanded] = React.useState("panel1");
  const [controller, dispatch] = useMaterialUIController();

  const navigate = useNavigate();
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const listMenu = useRef(null);
  const myRef = useRef(null);
  const serachIconHandler = (value, text = "") => {
    setSearchDisplay(value);
    setSearch(text);
  };
  const handleSearch = (searxhParam) => {
    setSearch(searxhParam);
    if (searxhParam > 0) {
      let smenu = [];
      if (menuType === "files") {
        smenu = SourceMenu.filter(
          (a) =>
            a.text.toLowerCase().includes(searxhParam.toLowerCase()) ||
            a.nationalCode.toLowerCase().includes(searxhParam.toLowerCase())
        );
      } else {
        smenu = SourceMenu.filter((a) =>
          a.text.toLowerCase().includes(searxhParam.toLowerCase())
        );
      }
      setMenu(smenu);
    } else {
      setMenu(SourceMenu);
    }
  };
  const createMenu = async (item, search = "") => {
    try {
      serachIconHandler(false);
      selectedItem = item;

      setHeader(dispatch, "addfile-search-notification-backpage");
      setTitle(dispatch, { title: item.text, subtitle: "" });
      console.log("itemitemitemitem", item);
      let newData = {
        capsule: item.id,
        search,
        fileMenuType: fileMenuType,
      };
      setLoading(dispatch, true);
      let res = await getUsersFilesWithCapsule(newData, controller);
      setLoading(dispatch, false);
      console.log("createMenu", res);
      if (res.success) {
        SourceMenu = res.data;

        setMenu(res.data);

        if (fileMenuType === "capsule") {
          let menuDB = await localStorage.getItem("$menu");
          menuDB = JSON.parse(menuDB);
          menuDB.capsuleText = item.text;
          menuDB.capsule = item.id;

          localStorage.setItem("$menu", JSON.stringify(menuDB));
        }
      } else {
        SourceMenu = [];
        setMenu([]);
      }
      setLoading(dispatch, false);
      if (myRef.current !== null) {
        myRef.current.scrollIntoView();
      }
    } catch (err) {
      console.log(err);
      setLoading(dispatch, false);
      displayErrorMessage("fa");
    }
  };
  const menuClickHandler = async (item, result = false) => {
    try {
      serachIconHandler(false);
      selectedItem = item;
      let menu = await localStorage.getItem("$menu");
      menu = JSON.parse(menu);
      menu.isMyFile = item.isMyFile;
      menu.limitedFile = item.limited;
      menu.file = item.id;
      menu.nationalCode = item.nationalCode;
      menu.showResultOfFile = result;
      menu.from = "menu";
      menu.visitedpageslist = [];
      await localStorage.setItem("$menu", JSON.stringify(menu));
      let newData = {
        file: item.id,
        visible: true,
        isMyFile: item.isMyFile,
      };
      setFileVisible(newData, controller);

      navigate("/pageview");
      return;
    } catch (err) {}
  };

  //   const menuFavoritekHandler = async (item) => {
  //     let result = await storeAccountFavorite(item.id, controller);

  //     if (result.success) {
  //       Swal.fire({
  //         text: item.favorite
  //           ? getText("outfavorite", "fa")
  //           : getText("infavorite", "fa"),
  //         position: "bottom-end",
  //         background: "#03fca1",
  //         showConfirmButton: false,
  //         timer: 1500,
  //       });
  //       createMenu(selectedItem );
  //     } else {
  //     }
  //   };
  const closeHandle = () => {
    setOpen(false);
    setAction(dispatch, "closefile");
  };
  const setNotificationCount = async () => {
    try {
      if (controller.authenticated) {
        let result = await getUnreadedNotifications(controller);
        if (result.success) {
          if (result.data !== controller.notification) {
            setNotification(dispatch, result.data);
          }
        } else {
        }
      }
    } catch (err) {}
  };
  const initScreen = async () => {
    try {
      menuType = "files";
      let menuDB = await localStorage.getItem("$menu");

      if (menuDB) {
        menuDB = JSON.parse(menuDB);
      }
      createMenu({ id: menuDB.capsule, text: menuDB.capsuleText });
    } catch (err) {
      console.log();
    }
  };
  const manageActions = () => {
    if (controller.action) {
      if (controller.action.startsWith("addfile")) {
        setOpen(true);
        setMode("newfile");
        setSearchDisplay(false);
      } else if (controller.action.startsWith("filemenu")) {
        setOpen(true);
        setMode("filemenu");
        setSearchDisplay(false);
      } else if (controller.action.startsWith("backpage")) {
        navigate(-1);
        setSearchDisplay(false);
        return;
      } else if (controller.action.startsWith("search")) {
        if (searchDisplay) {
          setSearch("");
          setMenu(SourceMenu);
        }

        setSearchDisplay(!searchDisplay);
      }
      setAction(dispatch, "");
    }
  };
  useEffect(() => {
    initScreen();
    return () => {
      setNotificationCount();
      setAction(dispatch, "");
      setHeader(dispatch, "");
      setLoading(dispatch, false);
    };
  }, []);
  useEffect(() => {
    setNotificationCount();
    manageActions();
  }, [controller.action]);
  const handleClose = () => {
    setOpen(false);
    createMenu(selectedItem);
  };

  //   const sendToForumHandler = async () => {
  //     setOpen(false);
  //     setMode("sendToForum");
  //     setOpen(true);
  //   };
  const sendToCollegueHandler = async () => {
    setOpen(false);
    setMode("sendToCollegue");
    setOpen(true);
  };
  const sendToOtherClinicHandler = async () => {
    try {
      setOpen(false);
      setMode("sendtoclinic");
      setOpen(true);
    } catch (err) {
      catchMessage(err, "fa");
    }
  };
  const mouseDown = () => {
    startPress = Date.now();
    console.log("mouseDown", startPress);
  };

  function mouseUp(item) {
    console.log("mouseUp", startPress, Date.now() - startPress > delay, item);
    if (startPress !== null && Date.now() - startPress > delay) {
      let temp = [];

      temp.push({
        id: item.id,
        nationalCode: item.nationalCode,
        owner: item.owner,
        isMyFile: item.isMyFile,
      });
      setSelectedFiles(temp);

      setOpen(true);
      setMode("filemenu");
      setSearchDisplay(false);
    } else {
      menuClickHandler(item, true);
    }
    startPress = null;
  }
  return (
    <DashboardLayout>
      <DashboardNavbar title={getText("questions", "fa")} />
      <div
        style={{
          width: "100%",
        }}
        ref={myRef}
      ></div>
      {/* <PullToRefresh
        onRefresh={() => {
          createMenu(selectedItem);
        }}
      > */}
      <div
        style={{
          minHeight: document.getElementById("root").clientHeight - 105,
        }}
      >
        <div className={"fa" === "en" ? "listmenu" : "listmenu rtl"}>
          <List id="mainlist" key={`mainlist`} ref={listMenu}>
            {menuType === "files" && (
              <div
                style={{
                  width: "100%",
                  fontSize: 14,
                  textAlign: "center",
                  borderBottomWidth: 1,
                  marginTop: -5,
                  borderBottomColor: "#039dfc",
                  marginBottom: 5,
                }}
              >
                {getText("clicktoaddfile", "fa")}
                <Divider />
              </div>
            )}
            {menu &&
              menu.map((item, index) => (
                <>
                  <ListItem
                    style={{
                      height: 40,
                      cursor: "pointer",
                    }}
                    key={"btnx" + index}
                    button
                  >
                    {/* {menuType !== "files" && controller.controllerenticated && (
                      <ListItemIcon
                        style={{ width: 35, minWidth: 35 }}
                        onClick={() => {
                          // menuFavoritekHandler(item);
                        }}
                      >
                        <StarBorderIcon
                          style={{
                            fontSize: 17,
                            color: item.favorite ? "#fc9d03" : "#039dfc",
                          }}
                        />
                      </ListItemIcon>
                    )} */}
                    {menuType === "files" && (
                      <Checkbox
                        checked={
                          selectedFiles.filter((a) => a.id + "" == item.id + "")
                            .length > 0
                            ? true
                            : false
                        }
                        onChange={() => {
                          let temp = selectedFiles;
                          let exist = selectedFiles.filter(
                            (a) => a.id == item.id
                          );
                          if (exist.length > 0) {
                            temp = selectedFiles.filter(
                              (a) => a.id + "" !== item.id + ""
                            );
                            setSelectedFiles(temp);
                          } else {
                            temp.push({
                              id: item.id,
                              nationalCode: item.nationalCode,
                              owner: item.owner,
                              isMyFile: item.isMyFile,
                            });
                            setSelectedFiles(temp);
                          }
                          setReload(new Date());
                        }}
                        size="larg"
                      />
                    )}

                    <ListItemText
                      onClick={() => {
                        menuClickHandler(item, false);
                      }}
                    >
                      <>
                        {menuType === "files" && (
                          <div>
                            {item.nationalCode === "" && (
                              <>{getText("unsavedfile", "fa")}</>
                            )}
                            {item.nationalCode !== "" && (
                              <>
                                {item.text + " - " + item.nationalCode}
                                {item.owner !== "" && (
                                  <>
                                    <br />
                                    <div
                                      style={{
                                        color: "#505050",
                                        fontWeight: 500,
                                        fontSize: 12,
                                        marginRight: 8,
                                        marginLeft: 8,
                                      }}
                                    >
                                      {item.owner}
                                    </div>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        )}
                        {menuType !== "files" && <div>{item.text}</div>}
                      </>
                    </ListItemText>

                    <ListItemIcon
                      style={{ width: 35, minWidth: 35 }}
                      onClick={() => {
                        menuClickHandler(item, false);
                      }}
                    ></ListItemIcon>
                  </ListItem>
                  <Divider key={`mainlistx${index}`} />
                </>
              ))}
          </List>
        </div>
      </div>
      {/* </PullToRefresh> */}

      <Drawer
        anchor="bottom"
        swipeAreaWidth={56}
        disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: true,
        }}
        open={open}
        onClose={closeHandle}
      >
        <div className="drawertitle">
          <IconButton
            style={{
              color: "#FFF",
              height: 35,
              width: 35,
              top: 5,
              position: "absolute",
              right: 5,
            }}
            aria-label="HighlightOffOutlinedIcon"
            onClick={() => {
              setOpen(false);
            }}
          >
            <HighlightOffOutlinedIcon />
          </IconButton>
          {mode == "newfile" && getText("newpatient", "fa")}
          {mode == "filemenu" && getText("menu", "fa")}
          {mode === "sendToForum" && getText("sendtoforum", "fa")}
          {mode === "sendtoclinic" &&
            getText("sendtootherclinic", "fa")}
          {mode === "sendToCollegue" &&
            getText("sendtocollegue", "fa")}
        </div>
        <div className="drawertext">
          {mode == "newfile" && (
            <NewPatientComponent
              props={props}
              closeHandle={closeHandle}
              selectedItem={selectedItem}
              createMenu={createMenu}
              handleSearch={handleSearch}
              from="menu"
              serachIconHandler={serachIconHandler}
              menuClickHandler={menuClickHandler}
            />
          )}
          {mode == "editfile" && (
            <EditPatientComponent
              props={props}
              closeHandle={closeHandle}
              selectedFiles={selectedFiles}
              selectedItem={selectedItem}
              createMenu={createMenu}
              from="menu"
              menuClickHandler={menuClickHandler}
            />
          )}
          {mode == "filemenu" && (
            <>
              <ListItem
                key={`deselectall`}
                autoFocus
                button
                onClick={() => {
                  let temp = [];

                  if (menu.length !== selectedFiles.length) {
                    menu.map((item, index) => {
                      temp.push({
                        id: item.id,
                        nationalCode: item.nationalCode,
                        owner: item.owner,
                        isMyFile: item.isMyFile,
                      });
                    });
                  }
                  setSelectedFiles(temp);
                }}
              >
                {menu.length !== selectedFiles.length && (
                  <IconButton color="primary" ria-label="CheckBoxIcon">
                    <CheckBoxIcon />
                  </IconButton>
                )}
                {menu.length === selectedFiles.length && (
                  <IconButton
                    color="primary"
                    ria-label="CheckBoxOutlineBlankIcon"
                  >
                    <CheckBoxOutlineBlankIcon />
                  </IconButton>
                )}

                <ListItemText
                  primary={
                    menu.length !== selectedFiles.length
                      ? getText("selectall", "fa")
                      : getText("deselectall", "fa")
                  }
                />
              </ListItem>
              {selectedFiles.length > 0 && (
                <>
                  {selectedFiles.length == 1 && (
                    <ListItem
                      key={`editfile`}
                      autoFocus
                      button
                      onClick={() => {
                        setOpen(false);
                        setMode("editfile");
                        setOpen(true);
                      }}
                    >
                      <IconButton
                        color="primary"
                        ria-label="ModeEditOutlinedIcon"
                      >
                        <ModeEditOutlinedIcon />
                      </IconButton>
                      <ListItemText
                        primary={getText("edit", "fa")}
                      />
                    </ListItem>
                  )}
                  <ListItem
                    key={`deleteconfirm`}
                    autoFocus
                    button
                    onClick={() => {
                      Swal.fire({
                        title: getText("warning", "fa"),
                        text: getText("deleteconfirm", "fa"),
                        cancelButtonText: getText("no", "fa"),
                        confirmButtonText: getText("yes", "fa"),
                        showCancelButton: true,
                      }).then(async (result) => {
                        if (result.isConfirmed) {
                          try {
                            let result = await deleteFiles(
                              selectedFiles,
                              controller
                            );
                            Swal.fire({
                              title: getText("alert", "fa"),
                              icon: "success",
                              text: result.message,
                              confirmButtonText: getText("ok", "fa"),
                            });
                            createMenu(selectedItem);
                            setOpen(false);
                          } catch (err) {
                            console.log(err);
                          }
                        }
                      });
                    }}
                  >
                    <IconButton color="primary" ria-label="DeleteOutlineIcon">
                      <DeleteOutlineIcon />
                    </IconButton>
                    <ListItemText
                      primary={getText("delete", "fa")}
                    />
                  </ListItem>

                  <ListItem
                    key={`sendtocollegue`}
                    autoFocus
                    button
                    onClick={() => {
                      sendToCollegueHandler();
                    }}
                  >
                    <IconButton color="primary" ria-label="PeopleAltIcon">
                      <PeopleAltIcon />
                    </IconButton>
                    <ListItemText
                      primary={getText("sendtocollegue", "fa")}
                    />
                  </ListItem>
                  <ListItem
                    key={`sendtootherclinic`}
                    autoFocus
                    button
                    onClick={() => {
                      sendToOtherClinicHandler();
                    }}
                  >
                    <IconButton color="primary" ria-label="HighlightOffIcon">
                      <FileCopyOutlinedIcon />
                    </IconButton>

                    <ListItemText
                      primary={getText("sendtootherclinic", "fa")}
                    />
                  </ListItem>
                </>
              )}
            </>
          )}

          {mode === "sendtoclinic" && (
            <ClinicsComponent
              handleClose={handleClose}
              selectedFiles={selectedFiles}
              capsule={selectedItem.id}
            />
          )}
          {mode === "sendToCollegue" && (
            <SendToColleagueComponent
              closeActionSheet={handleClose}
              fileInfo={{
                file: selectedFiles,
                capsule: selectedItem.id,
              }}
            />
          )}
        </div>
      </Drawer>

      {searchDisplay && (
        <Paper
          component="form"
          style={{
            padding: "1px 4px",
            display: "flex",
            alignItems: "center",
            margin: 0,
            left: 0,
            with: "100% !important",
            right: 0,
            bottom: 45,
            position: "fixed",
            borderRadius: 0,
            backgroundColor: "#ffc7d4",
            zIndex: 9999,
          }}
        >
          <IconButton
            color="primary"
            // className={classes.iconButton}
            aria-label="HighlightOffIcon"
            onClick={() => {
              setSearch("");
              setSearchDisplay(false);
              createMenu(selectedItem);
            }}
          >
            <CloseIcon />
          </IconButton>
          <InputBase
            value={search}
            fullWidth={true}
            autoFocus={true}
            onChange={(event) => {
              handleSearch(event.target.value);
            }}
          />

          <IconButton
            color="primary"
            // className={classes.iconButton}
            aria-label="search"
          >
            <SearchIcon />
          </IconButton>
        </Paper>
      )}

      <Footer />
    </DashboardLayout>
  );
}
